var map = {
	"./template.bet575": 1084,
	"./template.bet575.tsx": 1084,
	"./template.bet777": 1085,
	"./template.bet777.tsx": 1085,
	"./template.betgalaxy": 1086,
	"./template.betgalaxy.tsx": 1086,
	"./template.betprofessor": 2114,
	"./template.betprofessor.tsx": 2114,
	"./template.betroyale": 2115,
	"./template.betroyale.tsx": 2115,
	"./template.betstride": 1087,
	"./template.betstride.tsx": 1087,
	"./template.buffalobet": 2116,
	"./template.buffalobet.tsx": 2116,
	"./template.chromabet": 1088,
	"./template.chromabet.tsx": 1088,
	"./template.default": 656,
	"./template.default.tsx": 656,
	"./template.epicodds": 2117,
	"./template.epicodds.tsx": 2117,
	"./template.fiestabet": 2118,
	"./template.fiestabet.tsx": 2118,
	"./template.forsport": 1089,
	"./template.forsport.tsx": 1089,
	"./template.gigabet": 2119,
	"./template.gigabet.tsx": 2119,
	"./template.goldenbet888": 2014,
	"./template.goldenbet888.tsx": 2014,
	"./template.goldenrush": 2120,
	"./template.goldenrush.tsx": 2120,
	"./template.hyperbet": 1090,
	"./template.hyperbet.tsx": 1090,
	"./template.juicybet": 2121,
	"./template.juicybet.tsx": 2121,
	"./template.junglebet": 2122,
	"./template.junglebet.tsx": 2122,
	"./template.magnumbet": 1091,
	"./template.magnumbet.tsx": 1091,
	"./template.oldgill": 1092,
	"./template.oldgill.tsx": 1092,
	"./template.puntcity": 1093,
	"./template.puntcity.tsx": 1093,
	"./template.puntgenie": 1094,
	"./template.puntgenie.tsx": 1094,
	"./template.pyramidbet": 1095,
	"./template.pyramidbet.tsx": 1095,
	"./template.questbet": 1096,
	"./template.questbet.tsx": 1096,
	"./template.slambet": 2123,
	"./template.slambet.tsx": 2123,
	"./template.sterlingparker": 2124,
	"./template.sterlingparker.tsx": 2124,
	"./template.sugarcastle": 1097,
	"./template.sugarcastle.tsx": 1097,
	"./template.templebet": 2125,
	"./template.templebet.tsx": 2125,
	"./template.titanbet": 2126,
	"./template.titanbet.tsx": 2126,
	"./template.ts": 88,
	"./template.vikingbet": 1098,
	"./template.vikingbet.tsx": 1098,
	"./template.volcanobet": 1099,
	"./template.volcanobet.tsx": 1099,
	"./template.wellbet": 2127,
	"./template.wellbet.tsx": 2127
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2424;